module.exports = __webpack_public_path__ + "assets/img/index-gl_en-US.c56a8fa2.png";